import getHiddenFields from './getHiddenFields';

const getHiddenFieldsRecursively = ({
  fields = [],
  rules = [],
  values = {},
  config = {}
}) => {
  const results = {
    hidden: [],
    info: {},
    values: []
  };

  results.values = values;
  let iterations = 100;
  let oldValues;

  do {
    oldValues = JSON.parse(JSON.stringify(results.values));
    iterations--;

    let { hidden, info } = getHiddenFields({
      fields: fields,
      rules: rules,
      values: oldValues,
      config
    });
    results.info = info;
    results.hidden = hidden;

    hidden.forEach(hiddenFieldId => {
      if (results.values) {
        results.values[hiddenFieldId] = '';
      }
    });
  } while (
    JSON.stringify(oldValues) !== JSON.stringify(results.values) &&
    iterations > 0
  );

  return results;
};

export default getHiddenFieldsRecursively;
